
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores/[permalink]",
      function () {
        return require("private-next-pages/stores/[permalink].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stores/[permalink]"])
      });
    }
  